module.exports = __webpack_public_path__ + "img/doctor.c39e0890.svg";